import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { IPagination, ISimpleDriverDTO, IStoreState, IVehicleFilters, ITripEdit } from '../../types'
import { IActiveTripResponseV2, ITripFilters } from '../../types/trip'
import TripsScheduler from '../../components/trips/timeline-view/TripsScheduler'
import { actionCreators as mapsActionCreators } from '../../state/actions/google_map'
import { getDriversList, getOrgOperators, getOperatorSchedule } from '../../state/actions/drivers'
import { getVehicles, actionCreators as vehicleActionCreator } from '../../state/actions/vehicles'
import {
  assignOperator,
  getSchedulerTrips,
  updateSingleTrip,
  actionCreators as tripActionCreator
} from '../../state/actions/trips'
import { TripStatuses } from 'src/constants/trip-statuses'
import * as actions from '../../state/actions/trips'
import * as groupRideActions from '../../state/actions/group_ride'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps) {
  const { operatorSchedule } = state.drivers
  const vehiclesAndCount =
    state.vehicles && state.vehicles.items && state.vehicles.items.result
      ? { vehicles: Object.values(state.vehicles.items.result), totalCount: state.vehicles.items.count }
      : { vehicles: null, totalCount: 0 }
  return {
    ...ownProps,
    currentUserId: state.user.currentUserId,
    currentOrganizationId: state.organizations.currentOrgId,
    showMembers: state.trips.settings.showMembers,
    tripFilters: state.trips.filters,
    zones: state.goinzones.items,
    visible: state.goinzones.visible,
    drivers: Object.values(state.drivers.items),
    liveDrivers:
      state.drivers.items && state.drivers.liveOperators
        ? Object.values(state.drivers.items).filter(operator =>
            state.drivers.liveOperators.find(ping => ping.userId === operator.id)
          )
        : [],
    vehicles: vehiclesAndCount.vehicles,
    vehicleFilters: state.vehicles.filters,
    trips: Object.values(state.trips.items),
    operatorSchedule
  }
}

export function mapDispatchToProps(dispatch: any) {
  const { actionCreators: tripActionCreators } = actions

  return {
    fetchTrips: (filters: ITripFilters, pagination?: IPagination) => {
      const combinedFilters = { ...filters, ...pagination }
      if (!filters.orgId) {
        return
      }
      return dispatch(getSchedulerTrips(combinedFilters))
    },
    updateSingleTrip: (trip: IActiveTripResponseV2) => {
      return dispatch(updateSingleTrip(trip))
    },
    fetchAllVehicles: (params: IVehicleFilters) => {
      dispatch(getVehicles(params))
    },
    updateVehicleFilters: (params: IVehicleFilters) => dispatch(vehicleActionCreator.updateVehicleFilters(params)),
    getOperators: (organizationId: string, serviceIds?: string[]) => {
      return dispatch(
        getDriversList({
          organizationId,
          serviceIds,
          skip: 0,
          take: 1000
        })
      )
    },
    getOrgOperators: (orgId: string) => dispatch(getOrgOperators(orgId)),
    setCurrentTripStage: (stage: string) => dispatch(mapsActionCreators.setMapViewStrategyStage(stage)),
    assignOperator: (tripId: string, lastStatus: string, operator: ISimpleDriverDTO, isOndemandTrip: boolean) => {
      const setScheduled = isOndemandTrip ? false : lastStatus !== TripStatuses.SCHEDULED
      // const setDispatchAssignedDriver = isOndemandTrip ? true : false
      return dispatch(assignOperator(tripId, operator, setScheduled))
    },
    updateTripFilters: (filters: ITripFilters) => {
      return dispatch(actions.actionCreators.updateTripFilters(filters))
    },
    setCurrentTrip: (tripId: string) => dispatch(tripActionCreators.setCurrentTrip(tripId)),
    assignScheduledGroupRideOperator: async (id: string, operator: ISimpleDriverDTO): Promise<any> => {
      return await dispatch(groupRideActions.assignOperator(id, operator))
    },
    unAssignScheduledGroupRideOperator: async (id: string): Promise<any> => {
      return await dispatch(groupRideActions.unAssignOperator(id))
    },
    fetchOperatorSchedule: async () => await dispatch(getOperatorSchedule()),
    saveData: async (params: ITripEdit): Promise<any> => {
      return await dispatch(actions.saveData(params))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripsScheduler)



// WEBPACK FOOTER //
// ./src/containers/trips/TripsScheduler.ts